// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fake-input[data-v-647f72be] {\n  border: 1px solid #dee2e6;\n  padding: 0.5em 0.7em;\n  border-radius: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
